






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Copyright extends Vue {
  currentYear!: number

  created () {
    const date = new Date()
    this.currentYear = date.getUTCFullYear()
  }
}
